<template src="./PostManageTemplate.html"> </template>

<script>
import postsService from "@/services/gmbPosts";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { SCHEDULE_TYPE } from "@/enums/schedule-type";
import { postsManageMixin } from "@/helpers/mixins/posts-manage";
import { POSTS_FORM_TYPE } from "@/enums/posts.enum";

export default {
  name: "PostsAddNew",
  mixins: [postsManageMixin],
  data() {
    return {
      viewTitle: this.$t("message.common.postsAdd"),
      editMode: false
    };
  },
  async created() {
    const queryIds = this.getFacilitiesIdsFromQuery();
    if (queryIds.length) {
      this.selectedFacilitiesIds = queryIds;
    } else {
      this.facilitiesOptions.value = 0;
    }

    await this.getFacilitiesIds();
  },

  mounted() {
    if (this.$route.query.type === "fb") {
      this.type = POSTS_FORM_TYPE.POST;
    }
  },

  methods: {
    async send() {
      this.$store.commit("company/SET_LOADING", true);
      const formData = this.getFromData();
      const fbPostData = this.$store.state.posts.fbPostData;
      const payload = {
        ...formData,
        ...(fbPostData && {
          facebook_page_id: fbPostData.facebook_page_id,
          facebook_post_id: fbPostData.id
        })
      };
      await postsService
        .postPost(payload)
        .then(() => {
          this.openAlertDialog(formData.publish_at);
          const eventParams = this.getEventParams(this.type, formData);
          const locationType = this.getLocationType();

          this.$gtm.trackCustomEvent({
            event: GTM_EVENT_NAME.POSTS_MASS_ADD,
            locations_selection_type: locationType,
            post_origin: this.$store.state.posts.fbPostData
              ? "facebook"
              : "manual",
            num_locations:
              this.facilitiesOptions.value === 0
                ? this.allFacilitiesIds.length
                : this.selectedFacilitiesIds.length,
            num_cities: locationType === "city" ? this.cities.length : null,
            num_groups:
              locationType === "groups"
                ? this.facilitiesGroupsIds.length
                : null,
            post_type: this.currentForm,

            photo: this.image
              ? {
                  height_px: this.image.height || null,
                  width_px: this.image.width || null,
                  size_kb:
                    Math.round((this.image.size / 1024) * 100) / 100 || null
                }
              : null,
            schedule: this.scheduleType,
            schedule_other_date:
              this.scheduleType === SCHEDULE_TYPE.OTHER_DATE
                ? formData.publish_at
                : null,
            ...eventParams
          });

          this.resetForm();
          if (this.scheduleType === SCHEDULE_TYPE.NOW) {
            this.$router.push({ name: "posts-list-sent" });
          } else {
            this.$router.push({ name: "posts-list-planned" });
          }
        })
        .catch(this.requestErrorHandler);
      this.$store.commit("company/SET_LOADING", false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/assets/scss/pages/postManage.scss"></style>
